module.exports = __webpack_public_path__ + "098c789055e4dcff6df04ac79d1c989f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/app/fonts/Ikaros-Regular.otf
// module id = 29
// module chunks = 0